import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslocoPipe } from '@jsverse/transloco';
import { MultiOrderStrategy } from '@zero/discover/domain';
import { commonRoutes } from 'constants/web-app-constants';
import { environment } from 'environments/environment';

@Component({
  selector: 'home-multi-order-strategy-card',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterLink, TranslocoPipe],
  templateUrl: './multi-order-strategy-card.component.html',
  styleUrl: './multi-order-strategy-card.component.scss',
})
export class MultiOrderStrategyCardComponent {
  @Input() public strategy: MultiOrderStrategy;

  public readonly url = commonRoutes.postlogin.multi_order_strategies;
  public readonly imageBase = environment.assetshost;
}
